module.exports = __webpack_public_path__ + "static/img/01-banner1.1d854b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/01-shouye/01-banner1.jpg
// module id = 0mYo
// module chunks = 1